import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'

import { doMentionAgent } from 'actions/tickets'
import {
  doUpdateNoteDraftDelayed,
  selectNewCommentIsSendable,
  doUpdateAndLogNewConversation,
  doUpdateNoteDraftToRecipientDelayed,
  doInvalidateNoteDraft,
  doUpdateNoteDraft,
} from 'ducks/drafts'
import {
  doUpdateAgentMention,
  doUpdateSuppressMentionSelector,
} from 'actions/app'

import { selectAgentsById } from 'selectors/agents/base'
import { selectDeviceTypeIsDesktop } from 'selectors/app'
import {
  selectIsMentioningAgent,
  selectSelectedMentionSelectorAgentId,
  selectSuppressMentionSelector,
  selectShowMentionSelector,
} from 'selectors/mentions'

import View from './view'

const select = state => {
  return {
    ticketId: 'new',
    showMentionSelector: selectShowMentionSelector(state),
    isDraftSendable: selectNewCommentIsSendable(state),
    agentsById: selectAgentsById(state),
    isDesktop: selectDeviceTypeIsDesktop(state),
    isMentioning: selectIsMentioningAgent(state),
    selectedMentionSelectorAgentId: selectSelectedMentionSelectorAgentId(state),
    suppressMentionSelector: selectSuppressMentionSelector(state),
  }
}

const perform = dispatch => {
  return {
    ...bindActionCreators(
      {
        doMentionAgent,
        doUpdateAgentMention,
        doUpdateSuppressMentionSelector,
      },
      dispatch
    ),
    // Curry-able fns
    updateDraftDelayed: (ticketId, prop, val, opts) =>
      dispatch(doUpdateNoteDraftDelayed(ticketId, prop, val, opts)),
    onDeleteDraft: ticketId => dispatch(doInvalidateNoteDraft(ticketId)),
    updateDraft: (ticketId, prop, val) =>
      dispatch(doUpdateNoteDraft(ticketId, prop, val)),
    updateAndSendDraft: (ticketId, prop, val) =>
      dispatch(doUpdateAndLogNewConversation(ticketId, prop, val)),
    updateRecipientDelayed: (ticketId, recipient) =>
      dispatch(doUpdateNoteDraftToRecipientDelayed(ticketId, recipient)),
  }
}

export default connect(select, perform)(View)
